module.exports = __webpack_public_path__ + "components/resort-webcams/static/spinner-30bc526445538dc5c54e0c2f733deaa6.gif";